export const camelCaseToDashed = text => {
  return text.replace(/[A-Z]/g, m => '-' + m.toLowerCase())
}
